import { FC, SVGProps } from 'react'

export const KnifeForkIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <g clipPath="url(#a)">
      <path
        fill="#fff"
        d="m19.48 17.005-7.843-7.842L2.475 0h-.716l-.146.372c-.386.98-.551 1.983-.477 2.9.084 1.045.481 1.95 1.148 2.616l7.153 7.153.943-.943 6.613 7.394c.658.658 1.79.697 2.487 0a1.76 1.76 0 0 0 0-2.487Zm-13.358-5.62L.52 16.985a1.76 1.76 0 0 0 0 2.487c.651.652 1.778.71 2.487 0l5.602-5.602-2.487-2.487ZM19.15 3.33l-3.177 3.178-.83-.83 3.178-3.177-.829-.829-3.177 3.178-.83-.83L16.664.844l-.829-.829L11.69 4.16a2.926 2.926 0 0 0-.853 1.896c-.01.181-.052.36-.12.53l2.692 2.692c.17-.069.348-.11.53-.12a2.925 2.925 0 0 0 1.896-.853l4.144-4.145-.829-.829Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
)
